import { DocService } from '@affine/core/modules/doc';
import { AccessibleFolderCacheStore } from '@affine/core/modules/organize';
import { LiveData, useLiveData, useService } from '@toeverything/infra';
import { useMemo } from 'react';

import { isDocInsidePrivateSystemFolder } from './doc-share-restrictions';

export function useDocShareRestrictions() {
  const docService = useService(DocService);
  const accessibleFolderCache = useService(AccessibleFolderCacheStore);
  const accessibleFolders = useLiveData(
    useMemo(
      () =>
        LiveData.from(accessibleFolderCache.watchAllAccessibleFolders(), []),
      [accessibleFolderCache]
    )
  );
  const isLocalCacheLoaded = useLiveData(
    accessibleFolderCache.isLocalCacheLoaded$
  );
  const isPopulated = useLiveData(accessibleFolderCache.isPopulated$);
  const isReady = isLocalCacheLoaded === true && isPopulated === true;
  const privateFolderDocShareBlocked = useMemo(
    () =>
      isReady &&
      isDocInsidePrivateSystemFolder(docService.doc.id, accessibleFolders),
    [accessibleFolders, docService.doc.id, isReady]
  );

  return { isReady, privateFolderDocShareBlocked };
}
